<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>勢能-About</h2>
            <h2 style="padding-top: 10px;">企業社會責任下載專區</h2>
        </div>
    </div>
</div>
<section class="ptb-100">
    <div class="container">
        <table class="styled-table">
            <thead>
                <tr>
                    <th style="width: 70%;">檔案</th>
                    <th style="width: 15%;">大小</th>
                    <th>下載</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let file of fileList">
                    <td>{{file.fileName}}</td>
                    <td>{{file.fileSize}}</td>
                    <td><a href="/assets/files/{{file.fileName}}" download="{{file.fileName}}"><i class="fas fa-download"></i></a></td>
                </tr>
            </tbody>
        </table>
    </div>
</section>